import React from 'react';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';
import '../../src/styles/App.css';

const Experience = () => {
  const ref = useIntersectionObserver();

  const experiences = [
    {
      title: 'Frontend Developer — Techsolab',
      period: '2020 — 2024',
      desc: '4 years of frontend development experience using React (JSX), JavaScript, TypeScript, HTML, CSS, Bootstrap, and jQuery. Focused on responsive UI, reusable components, and clean user experiences.'
    },
    {
      title: 'Backend Developer — Techsolab',
      period: '2023 — 2025',
      desc: '2 year of backend development experience using Python, FastAPI, ASP.NET, RESTful APIs, authentication systems, and backend business logic.'
    },
    {
      title: 'Database Developer — Techsolab',
      period: '2023 — 2024',
      desc: '1 year of experience working with PostgreSQL, SQL Server, and Supabase. Designed, optimized, and managed relational databases and queries.'
    },
    {
      title: 'Digital Marketing & Automation — Remote',
      period: '2022 — 2024',
      desc: 'Handled social media accounts, graphic designing, lead generation, SEO optimization, and automation workflows for remote companies. Worked on brand growth, marketing strategies, and customer engagement.'
    }
  ];

  return (
    <section id="experience" className="section">
      <div ref={ref} className="container container-lg" data-animate>
        <h2>Experience</h2>

        <div className="timeline">
          {experiences.map((exp, index) => (
            <div key={index} className="timeline-item">
              <h6>{exp.title}</h6>
              <p>{exp.period}</p>
              <p>{exp.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
